class DesktopNotificationClass
{
    public hasPermission(): Promise<void>
    {
        return new Promise((resolve, reject) =>
        {
            // do NOT implement Notification.requestPermission here.
            if (HasNotifications && 'granted' === window.Notification.permission)
            {
                resolve();
            }

            reject();
        });
    }

    public send(title: string, options: NotificationOptions = {}, events: Nullable<Partial<NotificationEvents>> = null): Promise<void | Notification>
    {
        return new Promise((resolve, reject) =>
        {
            this.hasPermission().then(() =>
            {
                let notification = new window.Notification(title, options);

                if (events)
                {
                    for (const event in events)
                    {
                        if (events.hasOwnProperty(event))
                        {
                            notification[event] = events[event];
                        }
                    }
                }

                resolve(notification);
            }).catch(() =>
            {
                reject();
            });
        });
    }
}

export const HasNotifications    = 'Notification' in window && typeof window.Notification !== 'undefined' && typeof window.Notification.permission !== 'undefined';
export const DesktopNotification = new DesktopNotificationClass();